import { render, staticRenderFns } from "./SkupoviDodatniSadrzaji.vue?vue&type=template&id=1390146a&scoped=true&"
import script from "./SkupoviDodatniSadrzaji.vue?vue&type=script&lang=js&"
export * from "./SkupoviDodatniSadrzaji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390146a",
  null
  
)

export default component.exports